(function () {
  var NAV_URL_ALIASES = {
    '/collections/towels': '/products/towel',
    '/collections/sneaker-protectors': '/products/crep-protect-sneaker-guards-2-0'
  };
  var FORCED_NAV_SELECTOR = '.cp-dnav__l3-panel a, .cp-dnav__left-feature, .cp-dnav__right-feature-card, .cp-dnav__daily-item, .cp-dnav__daily-cta';

  function isStandardLeftClick(event) {
    var button = typeof event.button === 'number' ? event.button : 0;
    return button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
  }

  function isNavigableHref(href) {
    if (!href) return false;
    var normalized = String(href).trim().toLowerCase();
    return normalized !== '' && normalized !== '#' && !normalized.startsWith('javascript:');
  }

  function normalizePathname(pathname) {
    if (!pathname) return '/';
    var normalized = pathname.replace(/\/+$/, '');
    return normalized === '' ? '/' : normalized;
  }

  function remapNavHref(href) {
    if (!isNavigableHref(href)) return href;
    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return href;
    }

    if (url.origin !== window.location.origin) {
      return url.toString();
    }

    var mappedPathname = NAV_URL_ALIASES[normalizePathname(url.pathname)];
    if (!mappedPathname) {
      return url.toString();
    }

    url.pathname = mappedPathname;
    return url.toString();
  }

  function getForcedNavLink(target) {
    if (!target || !target.closest) return null;
    var link = target.closest(FORCED_NAV_SELECTOR);
    if (!link) return null;
    return link.closest('.cp-dnav') ? link : null;
  }

  function getNav(itemOrPanel) {
    return itemOrPanel ? itemOrPanel.closest('.cp-dnav') : null;
  }

  function closeAll(nav) {
    if (!nav) return;
    nav.querySelectorAll('.cp-dnav__item.cp-is-open').forEach(function (item) {
      item.classList.remove('cp-is-open');
    });
    nav.querySelectorAll('.cp-dnav__panel--mega').forEach(function (panel) {
      setActive(panel, '');
    });
  }

  function setActive(panel, groupName) {
    var triggers = panel.querySelectorAll('[data-group-trigger]');
    var level3Panels = panel.querySelectorAll('[data-group-panel]');
    var leftFeatureCards = panel.querySelectorAll('[data-left-feature-card]');
    var rightFeatureCards = panel.querySelectorAll('[data-right-feature-card]');
    var leftFeatureWrap = panel.querySelector('.cp-dnav__left-feature-wrap');
    var rightFeatureWrap = panel.querySelector('.cp-dnav__right-feature-wrap');
    var shell = panel.querySelector('.cp-dnav__shell');
    var secondary = panel.querySelector('.cp-dnav__secondary');
    var currentTrigger = panel.querySelector('[data-group-trigger="' + groupName + '"]');
    var hasChildren = currentTrigger && currentTrigger.getAttribute('data-has-children') === 'true';
    var leftFeatureKey = currentTrigger ? (currentTrigger.getAttribute('data-left-feature') || '') : '';
    var rightFeatureKey = currentTrigger ? (currentTrigger.getAttribute('data-right-feature') || '') : '';

    triggers.forEach(function (trigger) {
      trigger.classList.toggle('is-active', trigger.getAttribute('data-group-trigger') === groupName);
    });

    level3Panels.forEach(function (level3) {
      var shouldShow = hasChildren && level3.getAttribute('data-group-panel') === groupName;
      level3.classList.toggle('is-active', shouldShow);
    });

    leftFeatureCards.forEach(function (feature) {
      feature.classList.toggle('is-active', leftFeatureKey !== '' && feature.getAttribute('data-left-feature-card') === leftFeatureKey);
    });

    rightFeatureCards.forEach(function (feature) {
      feature.classList.toggle('is-active', hasChildren && rightFeatureKey !== '' && feature.getAttribute('data-right-feature-card') === rightFeatureKey);
    });

    if (leftFeatureWrap) {
      leftFeatureWrap.classList.toggle('is-visible', leftFeatureKey !== '');
    }
    if (rightFeatureWrap) {
      rightFeatureWrap.classList.toggle('is-hidden', !hasChildren || rightFeatureKey === '');
    }
    if (shell) {
      shell.classList.toggle('is-no-secondary', !hasChildren);
    }
    if (secondary) {
      secondary.classList.toggle('is-hidden', !hasChildren);
    }
    if (panel.classList.contains('cp-dnav__panel--mega')) {
      panel.classList.toggle('is-collapsed', !hasChildren);
    }

  }

  function closePanel(item, panel) {
    item.classList.remove('cp-is-open');
    if (panel.classList.contains('cp-dnav__panel--mega')) {
      setActive(panel, '');
    }
  }

  function initMegaPanel(panel) {
    var triggers = panel.querySelectorAll('[data-group-trigger]');
    if (!triggers.length) return;

    setActive(panel, '');

    triggers.forEach(function (trigger) {
      var groupName = trigger.getAttribute('data-group-trigger');
      if (!groupName) return;

      trigger.addEventListener('mouseenter', function () {
        setActive(panel, groupName);
      });
      trigger.addEventListener('focus', function () {
        setActive(panel, groupName);
      });
    });

    var item = panel.closest('.cp-dnav__item');
    if (item) {
      item.addEventListener('mouseenter', function () {
        var nav = getNav(item);
        closeAll(nav);
        item.classList.add('cp-is-open');
        setActive(panel, '');
      });

      item.addEventListener('mouseleave', function () {
        closePanel(item, panel);
      });

      item.addEventListener('focusin', function () {
        var nav = getNav(item);
        closeAll(nav);
        item.classList.add('cp-is-open');
      });

      item.addEventListener('focusout', function (event) {
        var next = event.relatedTarget;
        if (!next || !item.contains(next)) {
          closePanel(item, panel);
        }
      });

      panel.addEventListener('mouseleave', function () {
        closePanel(item, panel);
      });
    }
  }

  function initSimplePanel(panel) {
    var item = panel.closest('.cp-dnav__item');
    if (!item) return;

    item.addEventListener('mouseenter', function () {
      var nav = getNav(item);
      closeAll(nav);
      item.classList.add('cp-is-open');
    });

    item.addEventListener('mouseleave', function () {
      closePanel(item, panel);
    });

    item.addEventListener('focusin', function () {
      var nav = getNav(item);
      closeAll(nav);
      item.classList.add('cp-is-open');
    });

    item.addEventListener('focusout', function (event) {
      var next = event.relatedTarget;
      if (!next || !item.contains(next)) {
        closePanel(item, panel);
      }
    });

    panel.addEventListener('mouseleave', function () {
      closePanel(item, panel);
    });
  }

  function bindForcedNavigationCapture() {
    if (window.__cpDnavForcedNavigationBound) return;
    window.__cpDnavForcedNavigationBound = true;

    function forceNavigate(event) {
      var link = getForcedNavLink(event.target);
      if (!link) return;

      if (event.type === 'pointerdown' && !isStandardLeftClick(event)) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var hrefAttr = link.getAttribute('href') || link.href;
      if (!isNavigableHref(hrefAttr)) return;

      var targetHref = remapNavHref(hrefAttr);
      if (!isNavigableHref(targetHref)) return;

      var nav = getNav(link);
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      }
      closeAll(nav);
      window.location.assign(targetHref);
    }

    // Capture-phase listeners ensure Child 2 links navigate before theme-level handlers can cancel the click.
    window.addEventListener('pointerdown', forceNavigate, true);
    window.addEventListener('click', forceNavigate, true);
  }

  function init() {
    bindForcedNavigationCapture();

    var nav = document.querySelector('.cp-dnav');
    if (!nav) return;

    // Reset any stale state potentially applied by other theme scripts/classes.
    closeAll(nav);
    nav.querySelectorAll('.cp-dnav__item.is-open').forEach(function (item) {
      item.classList.remove('is-open');
    });

    nav.querySelectorAll('.cp-dnav__panel--mega').forEach(initMegaPanel);
    nav.querySelectorAll('.cp-dnav__panel:not(.cp-dnav__panel--mega)').forEach(initSimplePanel);

    nav.addEventListener('mouseleave', function () {
      closeAll(nav);
    });

    document.addEventListener('pointermove', function (event) {
      if (!nav.contains(event.target)) {
        closeAll(nav);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAll(nav);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
